import { render, staticRenderFns } from "./ElementLibrarySelector.vue?vue&type=template&id=5d671f2f&scoped=true"
import script from "./ElementLibrarySelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElementLibrarySelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ElementLibrarySelector.vue?vue&type=style&index=0&id=5d671f2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d671f2f",
  null
  
)

export default component.exports